/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input, InputNumber } from "antd";
 
import { useState } from "react";
 



const InputNumberDemo = () => { // NOSONAR : ignore
    const [inputValue, setInputValue] = useState<string>('');

    // Function to handle changes in the Input field and allow only numbers
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Using regex to allow only digits
         
        const value = e.target.value.replace(/\D/g, '');
        setInputValue(value);
    };

    return(
        <>
            <InputNumber
                placeholder="input number"
                autoComplete="off"
                value={null}
                // onChange={handleInputNumberChange}
                onKeyDownCapture={(e) => {
                    // Allow only numeric keys and control keys (backspace, delete, etc.)
                  if (!/\d/.test(e.key) && !['Backspace', 'Delete', 'Tab'].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />

            <Input
                placeholder="Input only numbers"
                value={inputValue}
                onChange={handleInputChange} // Restricts input to numbers only
            />
        </>
    )
};

export default InputNumberDemo;